import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=03529924&"
import script from "./detail.ts?vue&type=script&lang=ts&"
export * from "./detail.ts?vue&type=script&lang=ts&"
import style0 from "../offlineResourceMgr.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports